import React from "react";

const Comment = () => {
  return (
    <section id="comment">
      <div className="dbline"></div>
      <div className="subheading">
        📝 Comment on a Pickup Line (Share Your Thoughts!)
      </div>
      method : <span className="method">POST</span>
      <div className="dbline"></div>
      Endpoint: <span className="method">POST /pickup-lines/comment/:id</span>
      <div className="dbline"></div>
      Description:
      <br /> Got something to say about a pickup line? Share your thoughts,
      witty comments, or even your best puns! 🗨️
      <div className="dbline"></div>
      Request Body:
      <br />
      <div className="idea">
        - `comment` (string, required) - Your brilliant comment or pun.
      </div>
      <div className="dbline"></div>
      Responses:
      <br />
      <ul className="disc">
        <li>
          <span className="method">200 OK</span> <br />
          <div className="idea">
            Congrats! You've added your comment to the pickup line. 🥳 Expect to
            see your masterpiece on the line's comments section. Keep those
            clever comments coming! 🤓
          </div>
        </li>
        <li>
          <span className="method">404 Not Found</span> <br />
          <div className="idea">
            Oops, the pickup line with that specific ID appears to have slipped
            away. 🤷‍♂️
          </div>
        </li>
        <li>
          <span className="method">500 Internal Server Error</span>
          <br />
          <div className="idea">
            {" "}
            Looks like our server is feeling a bit shy today. Don't worry; it'll
            be back soon! 🙈
          </div>
        </li>
      </ul>
      <div className="dbline"></div>
      <div className="line"></div>
    </section>
  );
};

export default Comment;
